import {useLayoutEffect} from 'react';
import {Outlet, useLocation} from 'react-router-dom';
import {useAuth} from '../store/AuthContext.jsx';

// Every page transition starts at the top, including sign-in on the same route.
export function RouteViewport() {
  const {key, hash} = useLocation();
  const {user} = useAuth();
  useLayoutEffect(() => {
    if (hash) {
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { id = hash.slice(1); }
      const target = document.getElementById(id);
      if (target) { target.scrollIntoView({behavior: 'instant'}); return; }
    }
    window.scrollTo({top: 0, left: 0, behavior: 'instant'});
  }, [key, hash, user?.id]);
  return <Outlet/>;
}
